// removed by extract-text-webpack-plugin
module.exports = {"EkycInput":"EkycInput","Required":"Required","input-group-text":"input-group-text","form-control":"form-control","form-label":"form-label"};


//////////////////
// WEBPACK FOOTER
// ./src/screens/KisEkyc/Components/Input/style.scss
// module id = 2306
// module chunks = 10